<template>
    <div class="monster-box">
        <div class="row">
            <div class="col-sm-12">
                <div
                    class="d-flex justify-content-between align-items-center mb-2"
                >
                    <h3 class="mb-0 pb-0">{{ monster.name }}</h3>
                    <div
                        class="d-flex align-items-center"
                        @click="
                            $emit('roll-dice', {
                                skill: 1,
                                talent: 0,
                                statKey: monster.archetype,
                                rolltype: 'reaction',
                                monsterType: monster.type,
                            })
                        "
                    >
                        <h3 class="mb-0 pb-0 me-2" :class="monster.archetype">
                            {{ monster.type }}
                        </h3>
                        <div
                            class="skull-icon"
                            :class="monster.archetype"
                        ></div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-sm-4">
                        <p class="mb-0 pb-0">Speed: {{ monster.speed }}</p>
                    </div>

                    <div class="col-sm-4 text-center">
                        <p class="mb-0 pb-0">Size: {{ monster.size }}</p>
                    </div>

                    <div class="col-sm-4 text-end">
                        <p class="mb-0 pb-0">CR {{ monster.cr }}</p>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-sm-4">
                        <p class="mb-0 pb-0">Immun: {{ monster.immunities }}</p>
                    </div>

                    <div class="col-sm-4 text-center">
                        <p class="mb-0 pb-0">
                            Resist: {{ monster.resistances }}
                        </p>
                    </div>

                    <div class="col-sm-4 text-end">
                        <p class="mb-0 pb-0">Weak: {{ monster.weaknesses }}</p>
                    </div>
                </div>

                <p>{{ monster.description }}</p>
            </div>

            <!-- Stats -->
            <div class="col-sm-12 mb-3">
                <div class="row">
                    <!-- GRIT -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="require(`@/../public/img/grit${theme}.png`)"
                            alt="grit icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('grit')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Grit</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.grit"
                            readonly
                        />
                    </div>

                    <!-- WIT -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="require(`@/../public/img/wit${theme}.png`)"
                            alt="wit icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('wit')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Wit</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.wit"
                            readonly
                        />
                    </div>

                    <!-- HEART -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="require(`@/../public/img/heart${theme}.png`)"
                            alt="heart icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('heart')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Heart</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.heart"
                            readonly
                        />
                    </div>

                    <!-- SMARTS -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="require(`@/../public/img/smarts${theme}.png`)"
                            alt="smarts icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('smarts')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Smarts</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.smarts"
                            readonly
                        />
                    </div>

                    <!-- LUCK -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="require(`@/../public/img/luck${theme}.png`)"
                            alt="luck icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('luck')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Luck</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.luck"
                            readonly
                        />
                    </div>

                    <!-- STRANGE -->
                    <div class="col-6 col-md-4 col-lg-2 text-center">
                        <img
                            :src="
                                require(`@/../public/img/strange${theme}.png`)
                            "
                            alt="strange icon"
                            class="img-fluid stat-img"
                            @click="requestDiceBox('strange')"
                            style="cursor: pointer"
                        />
                        <p class="text-center">Strange</p>
                        <input
                            type="number"
                            class="form-control text-center"
                            :value="monster.strange"
                            readonly
                        />
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="input-group mb-3">
                    <span class="input-group-text">Status Effect</span>
                    <select
                        class="form-control"
                        :value="selectedStatusEffect"
                        @change="onStatusChange"
                    >
                        <option disabled value="">Select a status…</option>
                        <option
                            v-for="(desc, name) in store.statusEffects"
                            :key="name"
                            :value="name"
                        >
                            {{ name }}
                        </option>
                    </select>
                </div>

                <!-- Active Status Effects (alerts) -->
                <div
                    v-if="
                        monster &&
                        monster.statusEffects &&
                        monster.statusEffects.length
                    "
                    class="mt-2"
                >
                    <div
                        v-for="(se, idx) in monster.statusEffects"
                        :key="se.name + '-' + idx"
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                    >
                        <strong>{{ se.name }}</strong> — {{ se.effect }}
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            @click.prevent="confirmRemoveStatusEffect(idx, se)"
                        ></button>
                    </div>
                </div>
            </div>

            <!-- Lifeline -->
            <div class="col-sm-12 mb-3">
                <LifelineTracker
                    v-if="monster"
                    :key="monsterIndex"
                    :initial="monster.lifeline"
                    :hp="monster.hp"
                    @update="updateLifeline"
                />
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <!-- Attacks -->
                    <MonsterAttacks
                        :attacks="monster.attacks"
                        :theme="store.theme"
                        @request-dice-box="requestDiceBox"
                    />
                </div>
                <div class="col-sm-6">
                    <!-- Abilities -->
                    <MonsterAbilities :abilities="monster.abilities" />
                </div>
            </div>

            <!-- Remove button -->
            <button
                class="btn btn-danger mt-3"
                @click="$emit('remove-monster', monster.name)"
            >
                Remove
            </button>
        </div>
    </div>
</template>

<script>
import Lifeline from "./Lifeline.vue";
import MonsterAbilities from "./MonsterAbilities.vue";
import MonsterAttacks from "./MonsterAttacks.vue";
import { useRosterStore } from "@/stores";

export default {
    name: "MonsterBox",
    components: {
        LifelineTracker: Lifeline,
        MonsterAbilities,
        MonsterAttacks,
    },
    props: {
        monster: {
            type: Object,
            required: true,
        },
        theme: {
            type: Number,
            required: true,
        },
        encounterId: {
            type: Number,
            required: true,
        },
        monsterIndex: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            store: useRosterStore(),
            selectedStatusEffect: "",
        };
    },
    methods: {
        requestDiceBox(statKey) {
            const skill = this.monster[statKey];
            const talent = 0;
            this.$emit("roll-dice", {
                skill,
                talent,
                statKey,
                rolltype: "skill",
                monsterType: null,
            });
        },
        updateLifeline(newVal) {
            // update local monster
            this.monster.lifeline = newVal;

            // persist into store
            this.store.updateMonsterInEncounter(
                this.encounterId,
                this.monsterIndex,
                { ...this.monster }
            );
        },
        // Ensure reactive array + persist helper
        ensureStatusArray() {
            if (!Array.isArray(this.monster.statusEffects)) {
                this.monster.statusEffects = [];
                // Persist creation
                this.persistMonster();
            }
        },
        persistMonster() {
            this.store.updateMonsterInEncounter(
                this.encounterId,
                this.monsterIndex,
                { ...this.monster }
            );
        },
        onStatusChange(e) {
            const name = e.target.value;
            if (!name) return;

            this.ensureStatusArray();

            // Skip duplicates
            if (this.monster.statusEffects.some((se) => se.name === name)) {
                this.selectedStatusEffect = "";
                e.target.value = "";
                return;
            }

            const effect = this.store.statusEffects?.[name] || "";
            this.monster.statusEffects.push({ name, effect });

            // Persist change to store
            this.persistMonster();

            // Reset UI selection
            this.selectedStatusEffect = "";
            e.target.value = "";
        },
        confirmRemoveStatusEffect(idx, se) {
            const ok = window.confirm(
                `Remove status effect "${se.name}" from ${this.monster.name}?`
            );
            if (!ok) return;

            this.monster.statusEffects.splice(idx, 1);
            this.persistMonster();
        },
    },
    mounted() {
        this.ensureStatusArray();
    },
};
</script>

<style scoped>
.monster-box {
    padding: 1rem;
    border-radius: 5px;
    margin: 0 1rem 0 0;
}
.skull-icon {
    width: 3rem;
    height: 3rem;

    /* use skull.svg as a mask */
    -webkit-mask-image: url("@/../public/img/skull.svg");
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    mask-image: url("@/../public/img/skull.svg");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;

    background-color: currentColor; /* inherits from .grit, .wit, etc. */
}
.grit {
    color: #ee8a3b;
}
.wit {
    color: #81c7ff;
}
.smarts {
    color: #fff05a;
}
.heart {
    color: #ee001f;
}
.luck {
    color: #73bd69;
}
.strange {
    color: #8c4796;
}
</style>

